import React, { Suspense, lazy } from 'react';
import styled from 'styled-components';
import YoutubeVideo from './YoutubeVideo';
import CommentBoxSkeleton from './CommentBoxSkeleton';

const CommentBox = lazy(() => import('./CommentBox'));

const Video = () => {
  return (
    <Wrapper>
      <YoutubeVideo />
      <Suspense fallback={<CommentBoxSkeleton />}>
        <CommentBox />
      </Suspense>
    </Wrapper>
  );
};

export default Video;


const Wrapper = styled.div`
  margin-top: 70px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: auto;
  padding: 20px;
  box-sizing: border-box;
  gap: 30px;

  /* Alienware Aurora 16X optimization (2560x1600) */
  @media (min-width: 2560px) {
    margin-top: 100px;
    padding: 40px 60px;
    max-width: 2560px;
    margin-left: auto;
    margin-right: auto;
    gap: 50px;
  }

  @media (min-width: 1920px) and (max-width: 2559px) {
    margin-top: 80px;
    padding: 30px 50px;
    gap: 40px;
  }

  @media (max-width: 768px) {
    padding: 10px;
    gap: 20px;
  }

  /* iPhone 15+ and Samsung Galaxy optimization */
  @media (max-width: 430px) {
    margin-top: 15px;
    padding: 8px;
    gap: 15px;
  }

  @media (max-width: 390px) {
    margin-top: 10px;
    padding: 5px;
    gap: 12px;
  }

  @media (max-width: 360px) {
    margin-top: 8px;
    padding: 3px;
    gap: 10px;
  }
`;
